/**
 * ClustersPage - Wrapper для кэширования данных Кластеров через React Query
 * НЕ изменяет логику Clusters.jsx, только кэширует API-запросы
 */
import { useQuery } from "@tanstack/react-query";
import api from "@/utils/api";
import Clusters from "@/pages/Clusters";

// Функции для загрузки данных
const fetchClustersData = async () => {
  const response = await api.get("/fast/stocks/clusters");
  return response.data;
};

const fetchSyncStatus = async () => {
  const response = await api.get("/sync/status");
  return response.data;
};

export default function ClustersPage() {
  // Кэшированные запросы
  const clustersQuery = useQuery({
    queryKey: ["clusters"],
    queryFn: fetchClustersData,
  });

  const syncStatusQuery = useQuery({
    queryKey: ["syncStatus"],
    queryFn: fetchSyncStatus,
  });

  // Собираем данные для передачи в компонент
  const cachedData = {
    clusters: clustersQuery.data?.clusters || [],
    all_clusters: clustersQuery.data?.all_clusters || [],
    products: clustersQuery.data?.products || [],
    brands: clustersQuery.data?.brands || [],
    synced: clustersQuery.data?.synced ?? false,
    syncStatus: syncStatusQuery.data || null,
  };

  const isLoading = clustersQuery.isLoading;

  // Функция обновления кэша
  const refetchAll = async () => {
    await Promise.all([
      clustersQuery.refetch(),
      syncStatusQuery.refetch(),
    ]);
  };

  // Передаём данные через props
  return (
    <Clusters
      cachedData={cachedData}
      cachedLoading={isLoading}
      onRefetch={refetchAll}
    />
  );
}
